export default __webpack_public_path__ + "static/media/bw-executive-function-tutorial-pop-up-step-1.8b8b988b.svg";